import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { CredentialCustomFilterRequestComponent } from './credential-custom-filter-request.component';
import { UiComponentsModule, MultiSelectModule } from '@certemy/ui-components';

@NgModule({
  declarations: [CredentialCustomFilterRequestComponent],
  imports: [CertemyCommonModule, UiComponentsModule, MultiSelectModule],
  exports: [CredentialCustomFilterRequestComponent],
})
export class CredentialCustomFilterRequestModule {}
